import ActionTypes from 'store/actionTypes/admin/mentorLists';
import GetOrderValue from 'types/GetOrderValue';
import Tags from 'types/Tags';

export type List = 'main' | 'associate' | 'history' | 'ongoing' | 'interview';

type SetPage = (
  list: List,
  page: number,
) => { type: ActionTypes; value: number };
export const setPage: SetPage = (list, page) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_PAGE,
        value: page,
      };
    case 'associate':
      return {
        type: ActionTypes.ASSOCIATE_SET_PAGE,
        value: page,
      };
    case 'history':
      return {
        type: ActionTypes.HISTORY_SET_PAGE,
        value: page,
      };
    case 'ongoing':
      return {
        type: ActionTypes.ONGOING_SET_PAGE,
        value: page,
      };
    case 'interview':
      return {
        type: ActionTypes.INTERVIEW_SET_PAGE,
        value: page,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_PAGE,
        value: 0,
      };
  }
};

type SetSearch = (
  list: List,
  search: string,
) => { type: ActionTypes; value: string };
export const setSearch: SetSearch = (list, search) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_SEARCH,
        value: search,
      };
    case 'associate':
      return {
        type: ActionTypes.ASSOCIATE_SET_SEARCH,
        value: search,
      };
    case 'history':
      return {
        type: ActionTypes.HISTORY_SET_SEARCH,
        value: search,
      };
    case 'ongoing':
      return {
        type: ActionTypes.ONGOING_SET_SEARCH,
        value: search,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_SEARCH,
        value: '',
      };
  }
};

type SetTags = <TagColumnNames extends string>(
  list: List,
  tags: Tags<TagColumnNames>,
) => { type: ActionTypes; value: Tags<TagColumnNames> };
export const setTags: SetTags = (list, tags) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_TAGS,
        value: tags,
      };
    case 'associate':
      return {
        type: ActionTypes.ASSOCIATE_SET_TAGS,
        value: tags,
      };
    case 'history':
      return {
        type: ActionTypes.HISTORY_SET_TAGS,
        value: tags,
      };
    case 'ongoing':
      return {
        type: ActionTypes.ONGOING_SET_TAGS,
        value: tags,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_TAGS,
        value: tags,
      };
  }
};

type SetCustomTags = <CustomTags extends Record<string, unknown>>(
  list: List,
  customTags: CustomTags,
) => { type: ActionTypes; value: CustomTags };
export const setCustomTags: SetCustomTags = (list, customTags) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_CUSTOM_TAGS,
        value: customTags,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_CUSTOM_TAGS,
        value: customTags,
      };
  }
};

type SetActiveColumns = <Columns extends { [key: string]: boolean }>(
  list: List,
  activeColumns: Columns,
) => { type: ActionTypes; value: Columns };
export const setActiveColumns: SetActiveColumns = (list, activeColumns) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_ACTIVE_COLUMNS,
        value: activeColumns,
      };
    case 'associate':
      return {
        type: ActionTypes.ASSOCIATE_SET_ACTIVE_COLUMNS,
        value: activeColumns,
      };
    case 'history':
      return {
        type: ActionTypes.HISTORY_SET_ACTIVE_COLUMNS,
        value: activeColumns,
      };
    case 'ongoing':
      return {
        type: ActionTypes.ONGOING_SET_ACTIVE_COLUMNS,
        value: activeColumns,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_ACTIVE_COLUMNS,
        value: activeColumns,
      };
  }
};

type SetExportColumns = <Columns extends Record<string, boolean>>(
  list: List,
  activeColumns: Columns,
) => { type: ActionTypes; value: Columns };
export const setExportColumns: SetExportColumns = (list, exportColumns) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_EXPORT_COLUMNS,
        value: exportColumns,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_EXPORT_COLUMNS,
        value: exportColumns,
      };
  }
};

type SetTake = (
  list: List,
  take: number,
) => { type: ActionTypes; value: number };
export const setTake: SetTake = (list, take) => {
  switch (list) {
    case 'main':
      console.log('a');
      return {
        type: ActionTypes.MAIN_SET_TAKE,
        value: take,
      };
    case 'associate':
      return {
        type: ActionTypes.ASSOCIATE_SET_TAKE,
        value: take,
      };
    case 'history':
      return {
        type: ActionTypes.HISTORY_SET_TAKE,
        value: take,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_TAKE,
        value: 55,
      };
  }
};

type SetOrder = <OrderValue extends GetOrderValue<string>>(
  list: List,
  order: OrderValue,
) => { type: ActionTypes; value: OrderValue };
export const setOrder: SetOrder = (list, order) => {
  switch (list) {
    case 'main':
      return {
        type: ActionTypes.MAIN_SET_ORDER,
        value: order,
      };
    case 'associate':
      return {
        type: ActionTypes.ASSOCIATE_SET_ORDER,
        value: order,
      };
    case 'history':
      return {
        type: ActionTypes.HISTORY_SET_ORDER,
        value: order,
      };
    case 'interview':
      return {
        type: ActionTypes.INTERVIEW_SET_ORDER,
        value: order,
      };
    default:
      return {
        type: ActionTypes.MAIN_SET_ORDER,
        value: order,
      };
  }
};
